<template lang="pug">
div
  button.change-button(
    :disabled="disabled || loading"
    v-if="showButton"
    @click="show = true"
    data-testid="action-btn-revisar-reparacion"
  )
    b-spinner(v-if="loading" small)
    span(v-else) Revisar Reparación
  b-modal(
    v-model="show"
    size="lg"
    title="Revisar Reparación"
    id="modal-revisar-reparacion"
    hide-footer
    no-enforce-focus
  )
    .mb-2
      .row.mb-2
        .col-6
          span.font-weight-bold N° de Serie:
          |  {{ (ot.equipo && ot.equipo.serial_number) || '—' }}
        .col-6
          span.font-weight-bold RMA:
          |  {{ ot.rma || '—' }}
      .row.mb-3
        .col-6
          span.font-weight-bold Modelo:
          |  {{ (ot.equipo && ot.equipo.modelo_detail && ot.equipo.modelo_detail.model_name) || '—' }}
        .col-6
          span.font-weight-bold Falla reportada:
          |  {{ ot.reporte_falla_cliente || '—' }}
    b-form-group
      template(#label)
        span.font-weight-bold Diagnóstico:
      p.mb-0 {{ ot.diagnostico_detail && ot.diagnostico_detail.informe }}
    b-form-group
      template(#label)
        span.font-weight-bold Solución registrada por el técnico:
      b-form-textarea(v-model="form.solucion" rows="4")
    div.d-flex.justify-content-between.w-100.pt-2.pb-3
      b-button.btn-samtek-secondary(
        size="sm"
        variant="light"
        @click="show = false"
        :disabled="loading"
      ) Cancelar
      div
        b-button.btn-samtek-secondary.mr-2(
          size="sm"
          variant="light"
          @click="rechazar"
          :disabled="loading"
          data-testid="modal-reject-revisar-reparacion"
        ) Rechazar
        b-button.btn-samtek-primary(
          size="sm"
          @click="aprobar"
          :disabled="loading"
          data-testid="modal-approve-revisar-reparacion"
        ) Aprobar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionRevisarReparacion',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  data() {
    return {
      show: false,
      showButton: true,
      form: {
        solucion: this.ot?.diagnostico_detail?.solucion || '',
      },
    }
  },
  watch: {
    'ot.diagnostico_detail.solucion': {
      immediate: true,
      handler(val) {
        this.form.solucion = val || ''
      },
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
  methods: {
    ...mapActions('Warehouse', ['changeWarehouseState']),
    ...mapActions('OTStore', ['getOT', 'rechazarInformeReparacion']),
    async aprobar() {
      try {
        await this.executeWithLoading(async () => {
          if (this.form.solucion !== this.ot.diagnostico_detail?.solucion) {
            await this.$store.dispatch('Diagnosticos/updateDiagnoseOT', {
              id: this.ot.diagnostico_detail.id,
              solucion: this.form.solucion,
              orden_trabajo: this.ot.ot,
            })
          }

          const state =
            this.ot.tipo_servicio.id === 4 ? 'Reparado por pagar' : 'Reparado'
          await this.changeWarehouseState({
            state,
            orden: this.ot.ot,
            user: this.user.user.id,
          })
          this.$bvToast.toast('Reparación aprobada.', { variant: 'success' })
          await this.getOT(this.ot.ot)
          this.$emit('changed')
          this.show = false
        })
      } catch (error) {
        console.error('Error al aprobar reparación:', error)
        this.$bvToast.toast('Error al aprobar la reparación.', {
          variant: 'danger',
        })
      }
    },
    async rechazar() {
      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          '¿Seguro deseas rechazar la reparación?',
          {
            title: 'Por favor Confirma',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'SÍ',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        if (!confirmed) return
        await this.executeWithLoading(async () => {
          await this.rechazarInformeReparacion({ otId: this.ot.ot })
          this.$bvToast.toast(
            'Informe rechazado, OT devuelta a su estado anterior.',
            {
              variant: 'success',
            }
          )
          await this.getOT(this.ot.ot)
          this.$emit('changed')
          this.show = false
        })
      } catch (error) {
        console.error('Error al rechazar reparación:', error)
        this.$bvToast.toast('Error al rechazar la reparación.', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
